module.exports = "<div class=\"csi-tooltip-images\"\n\t><div data-csi-template-key=\"image\"\n\t></div\n></div>\n"